module.exports = __webpack_public_path__ + "img/index_video_test.112edb48.jpg";